import { Action } from 'redux';

import { IDatasourceActions } from '~src/datasource/ServerApi/types/IDatasourceActions';
import { IProjectActions } from '~src/projects/ServerApi/types/IProjectActions';
import { IWorkbookActions } from '~src/workbook/ServerApi/types/IWorkbookActions';

import { OpenContentDetailDialog } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface OpenContentDetailDialogAction extends Action {
  content: IContentInfo;
  availableActions?: IDatasourceActions|IWorkbookActions|IProjectActions;
  location?: string;
}

export function openContentDetailDialog(content: IContentInfo,
    availableActions?: IDatasourceActions|IWorkbookActions|IProjectActions, location?: string): OpenContentDetailDialogAction {
  return {
    type: OpenContentDetailDialog,
    content,
    availableActions,
    location
  };
}

export const isOpenContentDetailDialogAction = isActionFactory<OpenContentDetailDialogAction>(OpenContentDetailDialog);
